<template>
  <div
    class="integration-card"
    :class="`integration-card--${status}`"
    v-on="$listeners"
  >
    <div class="content-group">
      <span>
        <img class="integration-icon" :class="iconClass" :srcset="`${img}`" />
      </span>
      <span>
        {{ text }}
      </span>
    </div>
    <div class="option-group" :class="`option-group--${status}`">
      <font-awesome-icon class="icon" :icon="statusIcons[status]" />
      <span class="status-text">
        {{ $t(statusTexts[status]) }}
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'IntegrationCard',
  props: {
    img: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: null,
    },
    status: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      statusTexts: {
        connected: 'SETTINGS.LABEL.CONNECTED',
        connect: 'SETTINGS.LABEL.CONNECT',
        disabled:
          'SETTINGS.LABEL.SWITCH_TO_HIGHER_TIER_PLAN_TO_ENABLE_INTEGRATION',
      },
      statusIcons: {
        connected: ['fas', 'plug'],
        connect: ['fas', 'plug'],
        disabled: ['far', 'lock-alt'],
      },
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.integration-card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border: 1px solid $medium-gray;
  border-radius: 6px;
  min-height: 240px;
  justify-content: space-between;
  &--disabled {
    cursor: default;
  }
}

.content-group {
  padding: 1rem;
  display: flex;
  flex-direction: column;
}

.integration-icon {
  padding: 0.5rem 0 1.5rem;
  max-width: 30%;
  max-height: 80px;

  &.icon-small {
    max-width: 20%;
  }
  &.icon-smaller {
    max-width: 15%;
  }
}

.status-text {
  margin-left: 0.5rem;
}

.option-group {
  border-top: 1px solid $medium-gray;
  padding: 0.5rem 1rem;
  min-height: 42px;
  display: flex;
  align-items: center;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  &--connect {
    .icon {
      color: $coral;
    }
  }

  &--connected {
    background-color: $coral;
    .status-text,
    .icon {
      color: white;
    }
  }
}
</style>
